import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import { WizardProgress } from '../wizard/WizardComponents';
import ReviewSection from './ReviewSection';
import studentService from '../../services/studentService';

const RegistrationStep4 = ({ onNavigate, onSubmit, onLogout }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [policyLang,    setPolicyLang]    = useState('en');
  const [showPolicy,    setShowPolicy]    = useState(false);
  const [showError,     setShowError]     = useState(false);
  const [loading,       setLoading]       = useState(false);
  const [submitError,   setSubmitError]   = useState('');
  const [reviewData,    setReviewData]    = useState({ personal: [], family: [], permAddress: [], corrAddress: [], guardian: [], idProof: [], academic: [] });

  useEffect(() => {
    const s1 = JSON.parse(localStorage.getItem('registrationStep1Data') || '{}');
    const s2 = JSON.parse(localStorage.getItem('registrationStep2Data') || '{}');
    const s3 = JSON.parse(localStorage.getItem('registrationStep3Data') || '{}');
    const personal = [
      { label: 'Full Name',         value: s1.fullName       || 'Not provided' },
      { label: 'Date of Birth',     value: s1.dob            || 'Not provided' },
      { label: 'Gender',            value: s1.gender         || 'Not provided' },
      { label: 'Marital Status',    value: s1.maritalStatus  || 'Not provided' },
      { label: 'Religion',          value: s1.religion       || 'Not provided' },
      { label: 'Blood Group',       value: s1.bloodGroup     || 'Not provided' },
      { label: 'Mobile No.',        value: s1.mobile         || 'Not provided' },
      { label: 'Native Region',     value: s1.nativeRegion   || 'Not provided' },
      { label: 'Student Email ID',  value: s1.email          || 'Not provided' },
    ];
    const family = [
      { label: "Father's Name",       value: s1.fatherName   || 'Not provided' },
      { label: "Father's Mobile No.", value: s1.fatherMobile || 'Not provided' },
      { label: "Father's Email ID",   value: s1.fatherEmail  || 'Not provided' },
      { label: "Mother's Name",       value: s1.motherName   || 'Not provided' },
      { label: "Mother's Mobile No.", value: s1.motherMobile || 'Not provided' },
      { label: "Mother's Email ID",   value: s1.motherEmail  || 'Not provided' },
    ];
    const permAddress = [
      { label: 'Address Line 1', value: s1.permAddress1 || 'Not provided' },
      { label: 'Address Line 2', value: s1.permAddress2 || 'Not provided' },
      { label: 'City',           value: s1.permCity     || 'Not provided' },
      { label: 'Zip Code',       value: s1.permZipcode  || 'Not provided' },
      { label: 'State',          value: s1.permState    || 'Not provided' },
      { label: 'Country',        value: s1.permCountry  || 'Not provided' },
    ];
    const corrAddress = [
      { label: 'Address Line 1', value: s1.corrAddress1 || 'Not provided' },
      { label: 'City',           value: s1.corrCity     || 'Not provided' },
      { label: 'State',          value: s1.corrState    || 'Not provided' },
      { label: 'Country',        value: s1.corrCountry  || 'Not provided' },
    ];
    const guardian = [
      { label: "Local Guardian's Name", value: s1.localGuardianName || 'Not provided' },
      { label: 'Relation',              value: s1.guardianRelation  || 'Not provided' },
      { label: "Guardian's Mobile No.", value: s1.guardianMobile    || 'Not provided' },
      { label: 'Guardian Email ID',     value: s1.guardianEmail     || 'Not provided' },
      ...(s1.guardianIdType ? [
        { label: "Guardian's ID Type",   value: s1.guardianIdType === 'DrivingLicense' ? 'Driving License' : s1.guardianIdType === 'Aadhar' ? 'Aadhar Card' : 'Passport' },
        { label: "Guardian's ID Number", value: s1.guardianIdNumber || 'Not provided' },
      ] : []),
    ];
    const idProof = [
      { label: 'Aadhar Card No.',       value: s1.aadhar        || s3.aadharNumber         || 'Not provided' },
      { label: 'Emergency Contact No.', value: s1.emergencyContact || 'Not provided' },
      { label: 'Driving Licence No.',   value: s1.drivingLicense || s3.drivingLicenceNumber || 'Not provided' },
      { label: 'Passport No.',          value: s1.passport       || s3.passportNumber       || 'Not provided' },
      { label: 'PAN Card No.',          value: s1.panCard        || s3.panNumber            || 'Not provided' },
    ];
    const academic = [];
    if (s2.courses && s2.courses.length > 0) {
      s2.courses.forEach((c, i) => {
        if (c.universityName) {
          academic.push({ label: `University Name ${i + 1}`, value: c.universityName });
          academic.push({ label: `Academic Year ${i + 1}`,  value: c.academicYear });
          academic.push({ label: `Stream ${i + 1}`,         value: c.stream });
          academic.push({ label: `Timing ${i + 1}`,         value: c.timing });
          academic.push({ label: `Phone No. ${i + 1}`,      value: c.phoneNo });
        }
      });
    }
    if (s2.languages) {
      academic.push({ label: 'Languages (Write)', value: s2.languages.toWrite    || 'Not provided' });
      academic.push({ label: 'Languages (Speak)', value: s2.languages.toSpeak    || 'Not provided' });
      academic.push({ label: 'Languages (Read)',  value: s2.languages.toRead     || 'Not provided' });
      academic.push({ label: 'Mother Tongue',     value: s2.languages.motherTongue || 'Not provided' });
    }
    setReviewData({ personal, family, permAddress, corrAddress, guardian, idProof, academic });
  }, []);

  const handleSubmit = async () => {
    if (!termsAccepted) { setShowError(true); return; }
    setShowError(false); setLoading(true); setSubmitError('');
    try {
      const s1 = JSON.parse(localStorage.getItem('registrationStep1Data') || '{}');
      const s2 = JSON.parse(localStorage.getItem('registrationStep2Data') || '{}');
      const s3 = JSON.parse(localStorage.getItem('registrationStep3Data') || '{}');
      const registrationData = {
        fullName: s1.fullName, dob: s1.dob, gender: s1.gender,
        maritalStatus: s1.maritalStatus, religion: s1.religion, bloodGroup: s1.bloodGroup,
        nativeRegion: s1.nativeRegion, mobile: s1.mobile, email: s1.email,
        fatherName: s1.fatherName, fatherMobile: s1.fatherMobile || '', fatherEmail: s1.fatherEmail || '',
        motherName: s1.motherName || '', motherMobile: s1.motherMobile || '', motherEmail: s1.motherEmail || '',
        permanentAddress: { address1: s1.permAddress1, address2: s1.permAddress2 || '', city: s1.permCity, zipcode: s1.permZipcode, state: s1.permState, country: s1.permCountry },
        correspondenceAddress: { address1: s1.corrAddress1, address2: s1.corrAddress2 || '', city: s1.corrCity, zipcode: s1.corrZipcode, state: s1.corrState, country: s1.corrCountry },
        localGuardianName: s1.localGuardianName || '', guardianRelation: s1.guardianRelation || '',
        guardianMobile: s1.guardianMobile || '', guardianEmail: s1.guardianEmail || '',
        guardianIdType: s1.guardianIdType || '', guardianIdNumber: s1.guardianIdNumber || '',
        aadhar: s1.aadhar || s3.aadharNumber,
        emergencyContact: s1.emergencyContact || '',
        drivingLicense: s1.drivingLicense || s3.drivingLicenceNumber || '',
        passport: s1.passport || s3.passportNumber || '',
        languagesToWrite: s2.languages?.toWrite || '', languagesToSpeak: s2.languages?.toSpeak || '',
        languagesToRead: s2.languages?.toRead || '', motherTongue: s2.languages?.motherTongue || '',
        courses: (s2.courses || []).filter(c => c.universityName && c.academicYear && c.stream).map(c => ({
          universityName: c.universityName, academicYear: c.academicYear, stream: c.stream, timing: c.timing, phoneNo: c.phoneNo,
        })),
        termsAccepted: true,
      };
      const response = await studentService.registerStudent(registrationData);
      const studentId = response.id;
      let photoFile = window.selectedPhotoFile;
      if (!photoFile) {
        const saved = sessionStorage.getItem('regPhotoData');
        if (saved) {
          try {
            const { base64, name, type } = JSON.parse(saved);
            const byteStr = atob(base64.split(',')[1]);
            const arr = new Uint8Array(byteStr.length);
            for (let i = 0; i < byteStr.length; i++) arr[i] = byteStr.charCodeAt(i);
            photoFile = new File([arr], name, { type });
          } catch(e) { console.error('Could not restore photo', e); }
        }
      }
      if (photoFile && studentId) {
        try { await studentService.uploadPhoto(studentId, photoFile); } catch(e) { console.error('Photo upload failed:', e); }
      }
      const docFiles = window.selectedDocFiles;
      if (docFiles && studentId) {
        const hasAnyDoc = docFiles.aadharFront || docFiles.aadharBack || docFiles.drivingLicenseFront || docFiles.drivingLicenseBack || docFiles.passportFront || docFiles.passportBack || docFiles.panFront || docFiles.panBack;
        if (hasAnyDoc) {
          try { await studentService.uploadIdProofs(studentId, docFiles); } catch(e) { console.error('Doc upload failed:', e); }
        }
      }
      localStorage.setItem('completeRegistrationData', JSON.stringify({ ...registrationData, registrationId: response.registrationId, id: response.id, status: response.status, submittedAt: new Date().toISOString() }));
      localStorage.removeItem('registrationPhotoPreview');
      sessionStorage.removeItem('regPhotoData');
      window.selectedPhotoFile = null;
      window.selectedDocFiles = null;
      onSubmit();
    } catch (error) {
      setSubmitError(error.errors ? Object.entries(error.errors).map(([f,m]) => `${f}: ${m}`).join('\n') : (error.message || 'Failed to submit registration.'));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally { setLoading(false); }
  };

  const EN_RULES = [
    'Accommodation is provided with the understanding that the resident student will strictly adhere to the rules and regulations that are currently in force or may be enforced from time to time.',
    'Housing cannot be claimed as a matter of rights.',
    'The Omkara1 administration can deny accommodation to any student who is known to have violated the rules or whose presence is likely to disturb the peace and tranquility of the accommodation.',
    'Violation of accommodation rules will make the student liable for disciplinary action including permanent eviction from the residential building.',
    'Students should remember that this hostel is their second home away from home and therefore, he/she should behave in a manner both on and off campus in such a way that he/she and the institution get credit.',
    'Omkara Hostel residents are not allowed to use any electrical appliances ie. KETTLE, INDUCTION, IRON Etc. in the room. If found using appliance in the room will not be returned.',
    'Residents should not paste any POSTERS / PICTURES etc. on the walls, doors, cub-board, windows. Fine of Rs. 700/= will be levied.',
    'Outsider NOT ALLOWED in Omkara Hostel & not-allowed in the rooms, if we found in the room fine of Rs. 500/= will be levied.',
    'Laundry services are chargeable per cloth Rs. 20/-. Washing and Press for alternative basic use clothes. No valuable or expensive clothing should be given for laundry. In case of damage or loss Omkara Hostel authority will not take any responsibility for the same.',
    'Once enrolled in Omkara-1, a student will remain a student for the whole year, unless he is prohibited from stepping out of the house due to disciplinary reasons and will have to pay room rent for the entire academic year. Every student should be familiar with all the rules and regulations of housing. He/she should strictly adhere to it. Ignorance of the rules will not be taken as an excuse.',
    'Inspection: The warden or authorized staff has the right to inspect any room at any time for security or disciplinary reasons.',
    'Silence Hours: Quiet hours are usually observed from 10:00 p.m. to 6:00 a.m. to allow for study and sleep. Loud music or noise is prohibited during this time.',
    'Every student should stay in the room allotted to him/her. Reciprocal exchange of rooms after final allotment is not allowed. However, only the administrator can allow it as a special case for valid and reasonable reasons. Violation of the rule will be treated as an act of gross misconduct and appropriate disciplinary action will be taken including eviction from the residential building and imposition of heavy fines.',
    'Usage / Storage of LIQUOR, DRUGS, CIGARETTES, FLAWARE E.-CIGARETTES or any other INTOXICANTS in the OMKARA HOSTEL premises is strictly prohibited. If found action will be taken accordingly and student will be evicted. Fine of Rs. 3,000/- Three Thousand only. Will be levied.',
    "The student should see the notice board regularly. A member of the administrative team of any authorized member of hostel staff can inspect any student's room at any time. Hostel Students must carry any valid ID proof with them and submit it to any hostel authorities whenever requested.",
    'It is mandatory to report a complaint to the office for any issue. The complaint form should be WhatsApp and signed by the tenant. This work will be completed in a period of 6-8 days. Complaints will be registered only during office hours.',
    'Hostel seats will be allotted for the entire academic year. It is mandatory for the hostel residents to occupy the room allotted to them and should not change rooms without prior permission of the hostel authority.',
    'Omkara hostel_1 Under no circumstances should any furniture be taken from one place to another. Students are responsible for taking care of the furniture and fittings in their respective rooms. If there is any loss or damage, the cost of furniture and fittings will be recovered from them. Rs. 3,000/- will be charged.',
    'No outside food is allowed in Omkara1 hostel. If we get in the room, we will get Rs. A fine of Rs. 500/= will be levied.',
    'If any students found misbehaving and misconducting himself student will be evicted and fees will not be refunded.',
    'Omkara Hostel is required to be vacated with luggage in the vacation on a long leave.',
    'Management is free to increase fees structure depending upon the market conditions.',
    'Any Legal Disputes of Claims arising from OMKARA HOSTEL1 shall be subject to exclusive jurisdiction of the courts in AHMEDABAD, GUJARAT.',
  ];

  const EN_ACCOM = [
    'Accommodation will be provided only after FULL PAYMENT of the fees.',
    'The stated fees cover the period from 1st July to 31st May [Academic year 2026 – 2027].',
    'Fees must be paid 100% advance in one time at the time of admission.',
    'Room allotment is based on availability and will be assigned in series for the 1st July to 31st May academic year.',
    'No special preferences will be considered.',
    'All rights related to the OMKARA HOSTEL-1, ACCOMMODATION and MANAGEMENT are reserved exclusively by OMKARA HOSTEL-1 MANAGEMENT.',
  ];

  const EN_REFUND = [
    'If a student has to leave due to admission in DIFFERENT COLLEGE IN ANOTHER CITY: (i) Two Months charges will be deducted. (ii) The student must submit VERIFIED DOCUMENTS as a proof.',
    'After joining no refund will be granted.',
    'Pay Card Credit Balance and Deposit amount will be refunded after 45 Days after leaving OMKARA HOSTEL-1.',
  ];

  const GU_RULES = [
    'આવાસ એ સમજ સાથે પ્રદાન કરવામાં આવે છે કે નિવાસી વિદ્યાર્થી હાલમાં અમલમાં રહેલા નિયમો અને નિયમોનું કડક પાલન કરશે અથવા સમયાંતરે લાગુ થઈ શકે છે.',
    'આવાસનો અધિકારોની બાબત તરીકે દાવો કરી શકાતો નથી.',
    'ઓમકારા1 વહીવટીતંત્ર કોઈપણ વિદ્યાર્થીને આવાસ આપવાનો ઇનકાર કરી શકે છે જેણે નિયમોનું ઉલ્લંઘન કર્યું હોવાનું જાણીતું છે અથવા જેની હાજરીથી આવાસની શાંતિમાં ખલેલ પહોંચવાની સંભાવના છે.',
    'આવાસ નિયમોનું ઉલ્લંઘન વિદ્યાર્થીને રહેણાંક મકાનમાંથી કાયમી ધોરણે ખાલી કરાવવા સહિતની શિસ્તભંગની કાર્યવાહી માટે જવાબદાર બનાવશે.',
    'વિદ્યાર્થીઓએ યાદ રાખવું જોઈએ કે આ છાત્રાલય ઘરથી દૂર તેમનું બીજું ઘર છે અને તેથી, તેણે/તેણીએ કેમ્પસની અંદર અને બહાર એવી રીતે વર્તવું જોઈએ કે તેને અને સંસ્થાને શ્રેય મળે.',
    'ઓમકારા હોસ્ટેલના રહેવાસીઓને કોઈપણ ઇલેક્ટ્રિકલ ઉપકરણોનો ઉપયોગ કરવાની મંજૂરી નથી. ઓરડામાં કીટલી, ઇન્ડક્શન, વગેરે. જો રૂમમાં ઉપકરણનો ઉપયોગ કરતા જોવા મળે તો તે પરત કરવામાં આવશે નહીં.',
    'રહેવાસીઓએ દિવાલો, દરવાજા, ક્યુબ-બોર્ડ, બારીઓ પર કોઈ પોસ્ટર / ચિત્રો વગેરે ચોંટાડવા જોઈએ નહીં. 700/= રૂપિયાનો દંડ વસૂલવામાં આવશે.',
    'ઓમકારા હોસ્ટેલમાં આઉટ સાઇડની મંજૂરી નથી, જો અમને રૂમમાં મળી આવે તો રૂમમાં પ્રવેશવાની મંજૂરી નથી. 500/= રૂપિયાનો દંડ વસૂલવામાં આવશે.',
    'લોન્ડ્રી સેવાઓ કાપડ દીઠ રૂ. 20/- વસૂલવાપાત્ર છે. વૈકલ્પિક મૂળભૂત ઉપયોગના કપડાં ધોવા અને દબાવો. લોન્ડ્રી માટે કોઈ કિંમતી અથવા મોંઘા કપડાં આપવા જોઈએ નહીં. નુકસાનના કિસ્સામાં ઓમકારા હોસ્ટેલ ઓથોરિટી તેની કોઈ જવાબદારી લેશે નહીં.',
    'એકવાર ઓમકારા-1માં પ્રવેશ મેળવ્યા પછી, વિદ્યાર્થી આખું વર્ષ વિદ્યાર્થી રહેશે, સિવાય કે તેને શિસ્તના કારણોસર ઘરની બહાર નીકળવા પર પ્રતિબંધ ન હોય અને આખા શૈક્ષણિક વર્ષ માટે રૂમ ભાડું ચૂકવવું પડશે.',
    'નિરીક્ષણ: વોર્ડન અથવા અધિકૃત સ્ટાફને સુરક્ષા અથવા શિસ્તના કારણોસર કોઈપણ સમયે કોઈ પણ રૂમનું નિરીક્ષણ કરવાનો અધિકાર છે.',
    'સાયલન્સ અવર્સ: અભ્યાસ અને ઊંઘ માટે મંજૂરી આપવા માટે સામાન્ય રીતે રાત્રે 10:00 વાગ્યાથી સવારે 6:00 વાગ્યા સુધી શાંત કલાકો પાળવામાં આવે છે. આ સમય દરમિયાન મોટેથી સંગીત અથવા ઘોંઘાટ પ્રતિબંધિત છે.',
    'દરેક વિદ્યાર્થીએ તેને ફાળવવામાં આવેલા રૂમમાં રહેવું જોઈએ. અંતિમ ફાળવણી પછી ઓરડાઓના પારસ્પરિક વિનિમયની મંજૂરી નથી.',
    'દારૂ, ડ્રગ્સ, સિગારેટ, ફ્લેવેર સિગારેટનો વપરાશ/સંગ્રહ. ઓમકારા હોસ્ટેલ પરિસરમાં સિગારેટ અથવા અન્ય કોઈપણ નશા પદાર્થો પર સખત પ્રતિબંધ છે. 3,000/- રૂપિયાનો દંડ.',
    'વિદ્યાર્થીએ નિયમિતપણે નોટિસ બોર્ડ જોવું જોઈએ. હોસ્ટેલ સ્ટાફ કોઈપણ સમયે કોઈપણ વિદ્યાર્થીના રૂમનું નિરીક્ષણ કરી શકે છે.',
    'કોઈ પણ સમસ્યા માટે કચેરીમાં ફરિયાદ જાણ કરવી ફરજિયાત છે. ફરિયાદ ફોર્મ વોટ્સએપ હોવું જોઈએ. 8-10 દિવસના સમયગાળામાં પૂર્ણ થશે.',
    'સમગ્ર શૈક્ષણિક વર્ષ માટે છાત્રાલયની બેઠકો ફાળવવામાં આવશે. છાત્રાલય સત્તાધિકારીની પૂર્વ મંજૂરી વિના ઓરડા બદલવા જોઈએ નહીં.',
    'ઓમકારા hostel_1 કોઈ પણ સંજોગોમાં કોઈ પણ ફર્નિચર એક જગ્યાએથી બીજી જગ્યાએ લઈ જવું જોઈએ નહીં. 3,000/- રૂપિયા લેવામાં આવશે.',
    'ઓમકારા-1 હોસ્ટેલમાં બહારના ભોજનની મંજૂરી નથી. 500/= રૂપિયાનો દંડ.',
    'જો કોઈ વિદ્યાર્થી ગેરવર્તણૂક કરે છે તો વિદ્યાર્થીને હાંકી કાઢવામાં આવશે અને ફી પરત કરવામાં આવશે નહીં.',
    'ઓમકારા હોસ્ટેલ લાંબી રજા પર વેકેશનમાં સામાન સાથે ખાલી કરાવવી જરૂરી છે.',
    'મેનેજમેન્ટ બજારની પરિસ્થિતિઓના આધારે ફી સ્ટ્રક્ચરમાં વધારો કરવા માટે મુક્ત છે.',
    'ઓમકારા HOSTEL1માં દાવાઓના કોઈપણ કાનૂની વિવાદો અમદાવાદ, ગુજરાતની અદાલતોના વિશિષ્ટ અધિકારક્ષેત્રને આધિન રહેશે.',
  ];

  const GU_ACCOM = [
    'ફીની સંપૂર્ણ ચુકવણી કર્યા પછી જ આવાસ આપવામાં આવશે.',
    'જણાવેલ ફી 1લી જુલાઈથી 31મી મે સુધીના સમયગાળાને આવરી લે છે [શૈક્ષણિક વર્ષ 2026 - 2027].',
    'પ્રવેશ સમયે એક જ સમયે 100% એડવાન્સ ફી ચૂકવવી આવશ્યક છે.',
    'રૂમની ફાળવણી ઉપલબ્ધતા પર આધારિત છે.',
    'ઓમકારા હોસ્ટેલ-1 કોઈ ખાસ પસંદગીઓ ધ્યાનમાં લેવામાં આવશે નહીં.',
    'આવાસ અને વ્યવસ્થાપનને લગતા તમામ અધિકારો ફક્ત ઓમકારા હોસ્ટેલ-1 મેનેજમેન્ટ દ્વારા સુરક્ષિત છે.',
  ];

  const GU_REFUND = [
    'જો કોઈ વિદ્યાર્થીને બીજા શહેરની અલગ કોલેજમાં પ્રવેશને કારણે છોડવું પડે: (i) બે મહિનાના ચાર્જ કાપવામાં આવશે. (ii) વિદ્યાર્થીએ પુરાવા તરીકે ચકાસાયેલ દસ્તાવેજો સબમિટ કરવા.',
    'જોડાયા બાદ કોઈ રિફંડ આપવામાં આવશે નહીં.',
    'ઓમકારા હોસ્ટેલ-1 છોડ્યા પછી પે કાર્ડ ક્રેડિટ બેલેન્સ અને ડિપોઝિટની રકમ 45 દિવસ પછી પરત કરવામાં આવશે.',
  ];

  const isEn = policyLang === 'en';
  const rules  = isEn ? EN_RULES  : GU_RULES;
  const accom  = isEn ? EN_ACCOM  : GU_ACCOM;
  const refund = isEn ? EN_REFUND : GU_REFUND;

  const RuleItem = ({ text, bullet = '#', lang }) => (
    <div style={{ display:'flex', gap:10, marginBottom:10, fontSize:13, color:'#2C2C2C', lineHeight: lang === 'gu' ? 1.8 : 1.6, fontFamily: lang === 'gu' ? 'sans-serif' : 'inherit' }}>
      <span style={{ color:'#1B3B5F', fontWeight:700, flexShrink:0 }}>{bullet}</span>
      <span>{text}</span>
    </div>
  );

  return (
    <div className="app-layout">
      <Sidebar activeItem="registration" onNavigate={onNavigate} onLogout={onLogout} />
      <main className="main-content">
        <div className="top-bar"><h1 className="page-title">Final Review</h1></div>
        <div className="content-area">
          <div className="wizard-container">
            <WizardProgress currentStep={4} />
            <div className="wizard-card">
              {submitError && (
                <div style={{ padding:15, marginBottom:20, background:'#fee', border:'1px solid #e74c3c', borderRadius:8, color:'#e74c3c', whiteSpace:'pre-line', fontSize:14 }}>{submitError}</div>
              )}
              <div className="review-grid">
                <div>
                  <ReviewSection title="Personal Details"           data={reviewData.personal} />
                  <ReviewSection title="Family Details"             data={reviewData.family} />
                  <ReviewSection title="Permanent Address"          data={reviewData.permAddress} />
                  <ReviewSection title="Correspondence Address"     data={reviewData.corrAddress} />
                  <ReviewSection title="Guardian Details"           data={reviewData.guardian} />
                  <ReviewSection title="ID Proof Details"           data={reviewData.idProof} />
                  <ReviewSection title="Course & Language Details"  data={reviewData.academic} />
                </div>
                <div className="review-sidebar">
                  <div className="review-card">
                    <div className="review-photo">
                      {localStorage.getItem('registrationPhotoPreview') ? (
                        <img src={localStorage.getItem('registrationPhotoPreview')} alt="Student"
                          style={{ width:120, height:120, objectFit:'cover', borderRadius:'50%' }} />
                      ) : (
                        <span style={{ fontSize:60 }}>👤</span>
                      )}
                    </div>
                    <div className="review-name">{reviewData.personal.find(i => i.label === 'Full Name')?.value || 'Name Not Provided'}</div>
                    <div className="review-id">Registration ID: Pending</div>

                    <div className="review-terms">
                      {/* ── Policy Modal ── */}
                      {showPolicy && (
                        <div style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,0.55)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
                          <div style={{ background:'#fff', borderRadius:8, maxWidth:760, width:'100%', maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>

                            {/* Modal Header - close button only */}
                            <div style={{ padding:'14px 20px', borderBottom:'1px solid #E8E4DF', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
                              <h2 style={{ margin:0, fontSize:16, fontWeight:700, color:'#1B3B5F' }}>Omkara Hostel — Rules &amp; Policies</h2>
                              <button onClick={() => setShowPolicy(false)} style={{ background:'none', border:'none', fontSize:24, cursor:'pointer', color:'#9B9B9B', lineHeight:1 }}>×</button>
                            </div>

                            {/* Scrollable content */}
                            <div style={{ overflowY:'auto', padding:'20px 24px', flex:1 }}>

                              {/* Language Tab Toggle - always visible at top of content */}
                              <div style={{ display:'flex', marginBottom:20, border:'2px solid #1B3B5F', borderRadius:6, overflow:'hidden', width:'fit-content' }}>
                                <button
                                  onClick={() => setPolicyLang('en')}
                                  style={{ padding:'8px 24px', border:'none', cursor:'pointer', fontSize:13, fontWeight:700, background: isEn ? '#1B3B5F' : '#fff', color: isEn ? '#fff' : '#1B3B5F', transition:'all 0.2s' }}>
                                  English
                                </button>
                                <button
                                  onClick={() => setPolicyLang('gu')}
                                  style={{ padding:'8px 24px', border:'none', borderLeft:'2px solid #1B3B5F', cursor:'pointer', fontSize:13, fontWeight:700, background: !isEn ? '#1B3B5F' : '#fff', color: !isEn ? '#fff' : '#1B3B5F', transition:'all 0.2s' }}>
                                  ગુજરાતી
                                </button>
                              </div>

                              <h3 style={{ fontSize:14, fontWeight:700, color:'#1B3B5F', textDecoration:'underline', marginBottom:14 }}>
                                {isEn ? 'OMKARA HOSTEL RULES AND REGULATIONS' : 'ઓમકારા હોસ્ટેલના નીતિ-નિયમો'}
                              </h3>
                              {rules.map((rule, i) => <RuleItem key={i} text={rule} lang={policyLang} />)}

                              <div style={{ marginTop:24, paddingTop:18, borderTop:'2px solid #E8E4DF' }}>
                                <h3 style={{ fontSize:14, fontWeight:700, color:'#1B3B5F', textDecoration:'underline', marginBottom:12 }}>
                                  {isEn ? 'OMKARA HOSTEL-1 ACCOMMODATION AND REFUND POLICY' : 'ઓમકારા હોસ્ટેલ-1. આવાસ અને રિફંડ નીતિ'}
                                </h3>
                                {accom.map((item, i) => <RuleItem key={i} text={item} bullet="•" lang={policyLang} />)}
                                <h4 style={{ fontSize:13, fontWeight:700, color:'#1B3B5F', marginTop:16, marginBottom:10, textDecoration:'underline' }}>
                                  {isEn ? 'REFUND POLICY' : 'રિફંડ પોલિસી'}
                                </h4>
                                {refund.map((item, i) => <RuleItem key={i} text={item} lang={policyLang} />)}
                              </div>
                            </div>

                            {/* Footer */}
                            <div style={{ padding:'14px 24px', borderTop:'1px solid #E8E4DF', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
                              <span style={{ fontSize:12, color:'#9B9B9B' }}>Email: omkaraimpex1@gmail.com</span>
                              <button onClick={() => setShowPolicy(false)}
                                style={{ padding:'9px 24px', background:'#1B3B5F', color:'#fff', border:'none', borderRadius:4, cursor:'pointer', fontSize:13, fontWeight:600 }}>
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Checkbox */}
                      <div className="checkbox-wrapper" style={{ marginTop:16 }}>
                        <input type="checkbox" id="terms" checked={termsAccepted}
                          onChange={e => { setTermsAccepted(e.target.checked); if (e.target.checked) setShowError(false); }}
                          disabled={loading} />
                        <label htmlFor="terms" style={{ color: showError && !termsAccepted ? '#e74c3c' : '#2C2C2C', fontSize:13, lineHeight:1.5 }}>
                          I have read and agree to the{' '}
                          <span onClick={e => { e.preventDefault(); setShowPolicy(true); }}
                            style={{ color:'#1B3B5F', fontWeight:700, textDecoration:'underline', cursor:'pointer' }}>
                            Rules &amp; Regulations and Refund Policy
                          </span>
                          {' '}of Omkara Hostel *
                        </label>
                      </div>
                      {showError && !termsAccepted && (
                        <div style={{ color:'#e74c3c', fontSize:12, marginTop:8, fontWeight:500 }}>
                          You must read and accept the hostel rules before submitting.
                        </div>
                      )}
                    </div>

                    <div className="submit-actions">
                      <button className="btn-back" onClick={() => onNavigate('registration3', { isBack: true })} disabled={loading}>Back</button>
                      <button className="btn-submit" onClick={handleSubmit} disabled={loading || !termsAccepted} style={{ opacity: (termsAccepted && !loading) ? 1 : 0.7 }}>
                        {loading ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RegistrationStep4;